import InfoBox from "./infoBox";

export default InfoBox;
